import { BaseService } from "./base.service";
export class UniversityTemplateCriteriaService extends BaseService {
  constructor() {
    super("university-template-criteria");
  }
}
